module.exports = __webpack_public_path__ + "media/images/ui__themeToggleDark-9b139680e9e6da6f9521adf4f1ca2afe.png";